module.exports = __webpack_public_path__ + "306e013728c2882b129f9a033edd763a.fbx";